<script setup lang="ts">
</script>
<template>
  <div class="h-full w-full flex flex-col">
    <div class="grow-0">
      <slot name="header" />
    </div>
    <div class="grow overflow-y-auto">
      <slot />
    </div>
    <div class="grow-0">
      <slot name="footer" />
    </div>
  </div>
</template>
